var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ maxWidth: _vm.screenWidth }),attrs:{"id":"core-app-view"}},[_c('div',[_c('app-core-view'),_c('alert')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }